import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

console.log('host:' + document.location.host);

if(document.location.host === 'localhost:8080'){
    var endpoint = 'http://playworld-forum-backend.test/api/v1/';
    window.console.log('testomgeving lokaal');
}else if(document.location.host === 'test.playworld-forum.nl'){
    window.console.log('testomgeving');
    var endpoint = 'https://test.api.playworld-forum.nl/api/v1/';
}else{
    var endpoint = 'https://api.playworld-forum.nl/api/v1/';
}

const store=new Vuex.Store({
    state:{
        endpoint: endpoint,
        user:{
            id:0
        },
        token:'',
        sideBarMenusApi:{
            club:"menu/club",
            committee:'menu/committees',
            member:'menu/members'
        },
        currentSideMenu:[],
        alertMessage:{msg:'',show:false},
        requestStatus:{show:false , perc:0},
        lockscreen:{show:false}
    },
    getters:getters,
    mutations:mutations,
    actions:actions
});



export default store;